import axios from "@/lib/axios";

class IndividualCustomerService {
  constructor() {
    this.api = axios;
  }

  async getIndividualCustomers(query) {
    const { data } = await this.api.get("/individual-customers", {
      params: query,
    });

    return data;
  }

  // Advanced filtering and sorting endpoint
  async getIndividualCustomersAdvanced({ page = 1, size = 10, query = "", filter = [], sort = [] }) {
    // Build filter string: field:operator:value,field:operator:value
    const filterString = filter
      .filter((f) => f.value !== "" && f.value !== null && f.value !== undefined)
      .map((f) => `${f.field}:${f.operator}:${f.value}`)
      .join(",");

    // Build sort string: field:direction,field:direction
    const sortString = sort
      .filter((s) => s.field && s.direction)
      .map((s) => `${s.field}:${s.direction}`)
      .join(",");

    const params = { page, size };
    const trimmedQuery = query?.trim();
    if (trimmedQuery) params.query = trimmedQuery;
    if (filterString) params.filter = filterString;
    if (sortString) params.sort = sortString;

    const { data } = await this.api.get("/individual-customers/advanced", {
      params,
    });

    return data;
  }

  async getIndividualCustomer(id) {
    const { data } = await this.api.get(`/individual-customers/${id}`);

    return data;
  }

  async getIndividualCustomerProducts(id, filters) {
    const { data } = await this.api.get(
      `/individual-customers/${id}/products`,
      {
        params: filters,
      },
    );
    return data;
  }

  async deleteIndividualCustomerProduct(id, productId) {
    const { data } = await this.api.delete(
      `/individual-customers/${id}/products/${productId}`,
    );

    return data;
  }

  async remindIndividualCustomer(id, body) {
    const { data } = await this.api.post(
      `/individual-customers/${id}/remind`,
      body,
    );

    return data;
  }

  async updateWarrantyStartDate(
    individualCustomerProductId,
    warrantyStartDate,
  ) {
    const { data } = await this.api.put(`/individual-customers/warranty-date`, {
      individualCustomerProductId,
      warrantyStartDate,
    });

    return data;
  }

  async uploadBill(individualCustomerProductId, file) {
    const formData = new FormData();
    formData.append("billingFile", file);

    const { data } = await this.api.post(
      `/individual-customers/bill?individualCustomerProductId=${individualCustomerProductId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );

    return data;
  }
}

export default new IndividualCustomerService();
